module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3FkUy"))).then(() => module.bundle.root('4Y7My'));